import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import WalkInQueueService from "../../../../Services/WalkInQueue.service";
const FIRST_AVAILABLE = "";
class WalkInQueueModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.confirmationRef = React.createRef();
        this.state = {
            locations: [],
            departments: [],
            services: [],
            staff: [],
            selectedLocationId: null,
            selectedDepartmentId: null,
            selectedServiceId: null,
            selectedStaffPersonId: FIRST_AVAILABLE,
            question: "",
            isLoadingLocations: false,
            isLoadingDepartments: false,
            isLoadingServices: false,
            isSubmitting: false,
            submitError: null,
            confirmation: null,
            liveMessage: "",
        };
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleDepartmentChange = this.handleDepartmentChange.bind(this);
        this.handleServiceChange = this.handleServiceChange.bind(this);
        this.handleStaffChange = this.handleStaffChange.bind(this);
        this.handleQuestionChange = this.handleQuestionChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpened = this.handleOpened.bind(this);
    }
    componentDidUpdate(_, prevState) {
        if (!prevState.confirmation &&
            this.state.confirmation &&
            this.confirmationRef.current) {
            this.confirmationRef.current.focus();
        }
    }
    handleOpened() {
        const firstField = document.getElementById("wiq-location");
        if (firstField)
            firstField.focus();
        this.setState({
            locations: [],
            departments: [],
            services: [],
            staff: [],
            selectedLocationId: null,
            selectedDepartmentId: null,
            selectedServiceId: null,
            selectedStaffPersonId: FIRST_AVAILABLE,
            question: "",
            isLoadingLocations: true,
            submitError: null,
            confirmation: null,
            liveMessage: "Loading walk-in locations…",
        }, () => {
            WalkInQueueService.getLocations()
                .then((locations) => this.setState({
                locations,
                isLoadingLocations: false,
                liveMessage: "",
            }))
                .catch(() => this.setState({
                isLoadingLocations: false,
                submitError: "Failed to load walk-in locations.",
                liveMessage: "Failed to load walk-in locations.",
            }));
        });
    }
    handleLocationChange(e) {
        const locationId = e.target.value ? Number(e.target.value) : null;
        this.setState({
            selectedLocationId: locationId,
            selectedDepartmentId: null,
            selectedServiceId: null,
            selectedStaffPersonId: FIRST_AVAILABLE,
            departments: [],
            services: [],
            staff: [],
            submitError: null,
        }, () => {
            if (!locationId)
                return;
            this.setState({
                isLoadingDepartments: true,
                liveMessage: "Loading departments…",
            });
            WalkInQueueService.getDepartments(locationId)
                .then((departments) => this.setState({
                departments,
                isLoadingDepartments: false,
                liveMessage: "",
            }))
                .catch(() => this.setState({
                isLoadingDepartments: false,
                submitError: "Failed to load departments.",
                liveMessage: "Failed to load departments.",
            }));
        });
    }
    handleDepartmentChange(e) {
        const sdlId = e.target.value ? Number(e.target.value) : null;
        this.setState({
            selectedDepartmentId: sdlId,
            selectedServiceId: null,
            selectedStaffPersonId: FIRST_AVAILABLE,
            services: [],
            staff: [],
            submitError: null,
        }, () => {
            if (!sdlId)
                return;
            this.setState({
                isLoadingServices: true,
                liveMessage: "Loading services…",
            });
            WalkInQueueService.getServices(sdlId)
                .then((services) => this.setState({
                services,
                isLoadingServices: false,
                liveMessage: "",
            }))
                .catch(() => this.setState({
                isLoadingServices: false,
                submitError: "Failed to load services.",
                liveMessage: "Failed to load services.",
            }));
        });
    }
    handleServiceChange(e) {
        const serviceId = e.target.value ? Number(e.target.value) : null;
        this.setState({
            selectedServiceId: serviceId,
            selectedStaffPersonId: FIRST_AVAILABLE,
            staff: [],
        }, () => {
            const { selectedDepartmentId } = this.state;
            if (!serviceId || !selectedDepartmentId)
                return;
            this.setState({ liveMessage: "Loading staff…" });
            WalkInQueueService.getStaff(selectedDepartmentId, serviceId)
                .then((staff) => this.setState({ staff, liveMessage: "" }))
                .catch(() => this.setState({
                submitError: "Failed to load staff.",
                liveMessage: "Failed to load staff.",
            }));
        });
    }
    handleStaffChange(e) {
        this.setState({ selectedStaffPersonId: e.target.value });
    }
    handleQuestionChange(e) {
        this.setState({ question: e.target.value });
    }
    handleClose() {
        this.props.onModalClosed();
    }
    handleSubmit(e) {
        e.preventDefault();
        const { selectedDepartmentId, selectedServiceId, question, selectedStaffPersonId, } = this.state;
        if (!selectedDepartmentId || !selectedServiceId)
            return;
        this.setState({ isSubmitting: true, submitError: null });
        WalkInQueueService.enqueue({
            studentPersonId: this.props.studentPersonId,
            serviceDeliveryLocationId: selectedDepartmentId,
            serviceOfferingIds: [selectedServiceId],
            requestedWithPersonId: selectedStaffPersonId || undefined,
            question: question || undefined,
        })
            .then((result) => {
            this.setState({
                isSubmitting: false,
                confirmation: result,
                liveMessage: `${result.studentName} has been added to the walk-in queue at ${result.departmentName}.`,
            });
        })
            .catch((err) => {
            var _a;
            const msg = typeof err === "string"
                ? err
                : (_a = err === null || err === void 0 ? void 0 : err.message) !== null && _a !== void 0 ? _a : "An unexpected error occurred. Please try again.";
            this.setState({
                isSubmitting: false,
                submitError: msg,
                liveMessage: msg,
            });
        });
    }
    renderConfirmation(confirmation) {
        return (_jsxs(_Fragment, { children: [_jsxs(ModalBody, { children: [_jsxs("div", { ref: this.confirmationRef, tabIndex: -1, className: "alert alert-success", role: "status", children: [_jsx("strong", { children: confirmation.studentName }), " has been added to the walk-in queue."] }), _jsxs("dl", { className: "row mb-0", children: [_jsx("dt", { className: "col-sm-4", children: "Location" }), _jsx("dd", { className: "col-sm-8", children: confirmation.locationName }), _jsx("dt", { className: "col-sm-4", children: "Department" }), _jsx("dd", { className: "col-sm-8", children: confirmation.departmentName }), _jsx("dt", { className: "col-sm-4", children: "Service" }), _jsx("dd", { className: "col-sm-8", children: confirmation.serviceNames.join(", ") }), _jsx("dt", { className: "col-sm-4", children: "Staff" }), _jsx("dd", { className: "col-sm-8", children: confirmation.staffName })] })] }), _jsx(ModalFooter, { children: _jsx("button", { type: "button", className: "btn btn-primary", onClick: this.handleClose, children: "Close" }) })] }));
    }
    renderForm() {
        const { locations, departments, services, staff, selectedLocationId, selectedDepartmentId, selectedServiceId, selectedStaffPersonId, question, isLoadingLocations, isLoadingDepartments, isLoadingServices, isSubmitting, submitError, } = this.state;
        const noLocations = !isLoadingLocations && locations.length === 0;
        const canSubmit = !!selectedDepartmentId && !!selectedServiceId && !isSubmitting;
        return (_jsxs("form", { onSubmit: this.handleSubmit, children: [_jsxs(ModalBody, { children: [submitError && (_jsx("div", { id: "wiq-submit-error", className: "alert alert-danger", role: "alert", children: submitError })), _jsx("p", { className: "sr-only", id: "wiq-required-legend", children: "Fields marked with an asterisk are required." }), noLocations ? (_jsx("p", { className: "text-muted", children: "No walk-in services are currently accepting students. Please check staff availability settings or use the Meeting Scheduler." })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "wiq-location", children: ["Location ", _jsx("span", { "aria-hidden": "true", children: "*" })] }), _jsxs("select", { id: "wiq-location", className: "form-control", value: selectedLocationId !== null && selectedLocationId !== void 0 ? selectedLocationId : "", onChange: this.handleLocationChange, "aria-required": "true", "aria-busy": isLoadingLocations, disabled: isLoadingLocations, required: true, children: [_jsx("option", { value: "", children: isLoadingLocations ? "Loading…" : "Select a location" }), locations.map((loc) => (_jsx("option", { value: loc.id, children: loc.name }, loc.id)))] })] }), _jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "wiq-department", children: ["Department ", _jsx("span", { "aria-hidden": "true", children: "*" })] }), _jsxs("select", { id: "wiq-department", className: "form-control", value: selectedDepartmentId !== null && selectedDepartmentId !== void 0 ? selectedDepartmentId : "", onChange: this.handleDepartmentChange, "aria-required": "true", "aria-busy": isLoadingDepartments, "aria-describedby": "wiq-department-hint", disabled: !selectedLocationId || isLoadingDepartments, required: true, children: [_jsx("option", { value: "", children: isLoadingDepartments ? "Loading…" : "Select a department" }), departments.map((dept) => (_jsx("option", { value: dept.id, children: dept.name }, dept.id)))] })] }), _jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "wiq-service", children: ["Service ", _jsx("span", { "aria-hidden": "true", children: "*" })] }), _jsxs("select", { id: "wiq-service", className: "form-control", value: selectedServiceId !== null && selectedServiceId !== void 0 ? selectedServiceId : "", onChange: this.handleServiceChange, "aria-required": "true", "aria-busy": isLoadingServices, "aria-describedby": "wiq-service-hint", disabled: !selectedDepartmentId || isLoadingServices, required: true, children: [_jsx("option", { value: "", children: isLoadingServices ? "Loading…" : "Select a service" }), services.map((svc) => (_jsx("option", { value: svc.id, children: svc.name }, svc.id)))] })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "wiq-staff", children: "Preferred Staff" }), _jsxs("select", { id: "wiq-staff", className: "form-control", value: selectedStaffPersonId, onChange: this.handleStaffChange, disabled: !selectedDepartmentId || isLoadingServices, children: [_jsx("option", { value: "", children: "Next Available" }), staff.map((s) => (_jsx("option", { value: s.personId, children: s.fullName }, s.personId)))] })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "wiq-question", children: "Notes" }), _jsx("textarea", { id: "wiq-question", className: "form-control", value: question, onChange: this.handleQuestionChange, maxLength: 500, rows: 3, placeholder: "Reason for visit (optional)" })] })] }))] }), _jsxs(ModalFooter, { children: [_jsx("button", { type: "button", className: "btn btn-secondary", onClick: this.handleClose, disabled: isSubmitting, children: "Cancel" }), !noLocations && (_jsx("button", { type: "submit", className: "btn btn-primary", disabled: !canSubmit, "aria-busy": isSubmitting, children: isSubmitting ? "Adding…" : "Add to Walk-In Queue" }))] })] }));
    }
    render() {
        const { isOpen } = this.props;
        const { confirmation, liveMessage } = this.state;
        return (_jsxs(Modal, { isOpen: isOpen, toggle: this.handleClose, onOpened: this.handleOpened, "aria-labelledby": "wiq-modal-title", children: [_jsx("div", { "aria-live": "polite", "aria-atomic": "true", className: "sr-only", children: liveMessage }), _jsx(ModalHeader, { id: "wiq-modal-title", toggle: this.handleClose, tabIndex: -1, children: "Add to Walk-In Queue" }), confirmation
                    ? this.renderConfirmation(confirmation)
                    : this.renderForm()] }));
    }
}
export default WalkInQueueModal;
